<template>
  <page-content title="Meja 3: Pengukuran">
    <br />
    <c-input-date id="check-date" label="Tanggal Periksa">
      <datetime
        type="date"
        format="dd/LL/yyyy"
        value-zone="local"
        v-model="formBehavioralFactor.date"
      />
    </c-input-date>

    <div class="input-self-error">
      <v-select
        placeholder="Pasien yang diperiksa"
        label="fullname"
        :options="patients"
        :class="{ 'input-error': validations.patient.error }"
        v-model="patient"
      >
        <div slot="no-options">Tidak ada pasien tersedia.</div>
      </v-select>
      <p class="self-error-message" v-if="validations.patient.error">
        {{ validations.patient.message }}
      </p>
    </div>
    <br />

    <c-input
      id="weight"
      label="Berat Badan (kg)"
      type="number"
      v-model="formBehavioralFactor.weight"
      :error="validations.weight.error"
      :error-message="validations.weight.message"
    />

    <c-input
      id="height"
      label="Tinggi Badan (cm)"
      type="number"
      v-model="formBehavioralFactor.height"
      :error="validations.height.error"
      :error-message="validations.height.message"
    />

    <c-input
      id="weight"
      label="Lingkar Perut (cm)"
      type="number"
      v-model="formBehavioralFactor.waist"
      :error="validations.waist.error"
      :error-message="validations.waist.message"
    />

    <button
      class="btn btn-block btn-primary"
      @click="doSubmit"
      v-if="!isLoading"
    >
      Simpan
    </button>
    <p align="center" v-else>
      <pulse-loader :loading="isLoading" size="10px" :color="colorPrimary" />
    </p>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "measurement",
  data: function () {
    return {
      validations: {
        patient: {
          error: false,
          message: "Something went wrong.",
        },
        weight: {
          error: false,
          message: "Something went wrong.",
        },
        height: {
          error: false,
          message: "Something went wrong.",
        },
        waist: {
          error: false,
          message: "Something went wrong.",
        },
      },
      patient: "",
      isLoading: false,
    };
  },
  watch: {
    patient: function () {
      this.updateCheckup();
    },
    "formBehavioralFactor.date": function () {
      this.getQueuedPatients();
    },
  },
  computed: {
    ...mapGetters({
      patients: "queuedPatients",
      formBehavioralFactor: "checkup",
    }),
  },
  methods: {
    isFormValid: function () {
      // Reset the errors
      this.validations.patient.error = false;
      this.validations.weight.error = false;
      this.validations.height.error = false;
      this.validations.waist.error = false;

      if (this.isEmpty(this.patient)) {
        this.validations.patient.error = true;
        this.validations.patient.message = "Pasien harus diisi.";
      }
      if (this.isEmpty(this.formBehavioralFactor.weight)) {
        this.validations.weight.error = true;
        this.validations.weight.message = "Berat Badan harus diisi.";
      } else if (this.formBehavioralFactor.weight <= 0) {
        this.validations.weight.error = true;
        this.validations.weight.message = "Berat Badan tidak valid.";
      }
      if (this.isEmpty(this.formBehavioralFactor.height)) {
        this.validations.height.error = true;
        this.validations.height.message = "Tinggi Badan harus diisi.";
      } else if (this.formBehavioralFactor.height <= 0) {
        this.validations.height.error = true;
        this.validations.height.message = "Tinggi Badan tidak valid.";
      }
      if (this.isEmpty(this.formBehavioralFactor.waist)) {
        this.validations.waist.error = true;
        this.validations.waist.message = "Lingkar Perut harus diisi.";
      } else if (this.formBehavioralFactor.waist <= 0) {
        this.validations.waist.error = true;
        this.validations.waist.message = "Lingkar Perut tidak valid.";
      }

      for (const key in this.validations) {
        const field = this.validations[key];
        if (field["error"]) return false;
      }
      return true;
    },
    doSubmit: function () {
      if (this.isFormValid()) {
        this.isLoading = true;
        const userId = this.patient.id;
        const payload = this.formBehavioralFactor;
        this.$store
          .dispatch("createOrUpdateCheckup", { userId, payload })
          .then(() => {
            this.isLoading = false;
            this.$toasted.success("Berhasil disimpan.");
          })
          .catch(() => {
            this.isLoading = false;
            this.$toasted.error("Gagal! Terjadi kesalahan.");
          });
      }
    },
    updateCheckup: function () {
      this.$store.dispatch("resetCheckup");
      if (
        !this.isEmpty(this.patient) &&
        !this.isEmpty(this.formBehavioralFactor.date)
      ) {
        const userId = this.patient.id;
        const date = LuxonDateTime.fromISO(
          this.formBehavioralFactor.date
        ).toFormat("yyyy-LL-dd");
        this.$store.dispatch("getCheckup", { userId, date });
      }
    },
    getQueuedPatients: function () {
      const date = LuxonDateTime.fromISO(
        this.formBehavioralFactor.date
      ).toFormat("yyyy-LL-dd");
      this.$store.dispatch("startPageLoading");
      this.$store
        .dispatch("getQueuedPatients", date)
        .then(() => {
          this.$store.dispatch("stopPageLoading");
        })
        .catch(() => {
          this.$store.dispatch("stopPageLoading");
        });
    },
  },
  created: function () {
    this.getQueuedPatients();
  },
};
</script>
